import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import PaperDraggable from '../../../../../../components/PaperDraggable';
import SelecionarProduto, { InputsSelecionarProduto } from '../../../../../../components/BasicComponents/SelecionarProduto';
import { useFormContext } from 'react-hook-form';
import { enqueueSnackbar } from 'notistack';

export default function DialogSelecionarProduto({ open, onClose }: DialogSelecionarProdutoProps) {

    const { getValues, watch, setValue } = useFormContext<InputsSelecionarProduto>();

    const handleAddProducts = () => {
        const { items } = getValues();
        if (items.length === 0) {
            enqueueSnackbar("Selecione pelo menos um produto", { variant: "warning" });
            return;
        };

        const observacoes = items.map(item => {
            return {
                observacao: item.observacao,
                nome: item.nome,
                codigo: item.codigo
            }
        }).filter(item => item.observacao && item.observacao.trim() !== "")

        const observacoesText = observacoes.map(item => `- [${item.codigo}] ${item.nome}: ${item.observacao}`);

        setValue('observacao', observacoesText.length > 0 ? observacoesText.join("\n\n") : null);
        onClose();
    }


    return (
        <Dialog
            open={open}
            maxWidth="xl"
            fullWidth
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Selecione os produtos</DialogTitle>
            
            <DialogContent>
                    <SelecionarProduto />
            </DialogContent>

            <DialogActions>
                <Button
                    variant='outlined'
                    onClick={onClose}
                >
                    Fechar
                </Button>
                <Button
                    variant='contained'
                    onClick={() => {
                        handleAddProducts()
                    }}
                    disabled={watch('items').length === 0}
                >
                    Adicionar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogSelecionarProdutoProps {
    open: boolean
    onClose: () => void;
}


